import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Construction } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { useLanguage } from '../context/LanguageContext';

// Generic Coming Soon page that can be reused
const ComingSoonPage = ({ titleKey, icon: Icon = Construction }) => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const titles = {
    careers: { en: 'Careers', nl: 'Carrières' },
    blog: { en: 'Blog', nl: 'Blog' },
    caseStudies: { en: 'Case Studies', nl: 'Case Studies' },
    docs: { en: 'Documentation', nl: 'Documentatie' },
    faq: { en: 'FAQ', nl: 'FAQ' },
    privacy: { en: 'Privacy Policy', nl: 'Privacybeleid' },
    terms: { en: 'Terms of Service', nl: 'Algemene Voorwaarden' },
    cookies: { en: 'Cookie Policy', nl: 'Cookiebeleid' },
  };

  const title = titles[titleKey]?.[language] || titleKey;

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main className="py-12">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {/* Back Button */}
          <button
            onClick={() => navigate(-1)}
            className="flex items-center text-gray-600 hover:text-gray-900 mb-8 transition-colors mx-auto"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            {language === 'nl' ? 'Terug' : 'Back'}
          </button>

          <div className="bg-white rounded-2xl shadow-sm p-12">
            <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Icon className="h-10 w-10 text-blue-500" />
            </div>
            
            <h1 className="text-3xl font-bold text-gray-900 mb-4">{title}</h1>
            
            <p className="text-gray-600 mb-8">
              {language === 'nl' 
                ? 'Deze pagina is momenteel in ontwikkeling. Kom binnenkort terug!'
                : 'This page is currently under development. Check back soon!'}
            </p>
            
            <div className="space-y-3">
              <Button 
                onClick={() => navigate('/quickscan/start')}
                className="bg-blue-500 hover:bg-blue-600"
              >
                {language === 'nl' ? 'Start Gratis Quickscan' : 'Start Free Quickscan'}
              </Button>
              <p className="text-sm text-gray-500">
                {language === 'nl' ? 'of' : 'or'}
              </p>
              <Button 
                variant="outline"
                onClick={() => navigate('/contact')}
              >
                {language === 'nl' ? 'Neem Contact Op' : 'Contact Us'}
              </Button>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

// Export individual page components
export const CaseStudiesPage = () => <ComingSoonPage titleKey="caseStudies" />;
export const DocsPage = () => <ComingSoonPage titleKey="docs" />;
export const FAQPage = () => <ComingSoonPage titleKey="faq" />;
export const PrivacyPage = () => <ComingSoonPage titleKey="privacy" />;
export const TermsPage = () => <ComingSoonPage titleKey="terms" />;
export const CookiesPage = () => <ComingSoonPage titleKey="cookies" />;

export default ComingSoonPage;
